/**
 * Tiny registry so the "auto-save Agentic drafts to Saved Prescriptions when
 * leaving for New Rx Pad" behavior can fire from EITHER switch control — the
 * PadSwitcher dropdown or the "New Rx Pad" tab in the shared TabsNav.
 *
 * The AIPrescription page registers a saver while mounted; the switch controls
 * call runAgenticDraftSaver() right before navigating to /newrxpad. It is a
 * no-op anywhere else (no saver registered), so wiring it into the shared
 * TabsNav is safe for every other page.
 */

type Saver = () => void;

let saver: Saver | null = null;

/** Called by the AIPrescription page on mount (and cleared on unmount). */
export const setAgenticDraftSaver = (fn: Saver | null): void => {
  saver = fn;
};

/** Called by switch controls before routing to New Rx Pad. Safe no-op if unset. */
export const runAgenticDraftSaver = (): void => {
  try {
    saver?.();
  } catch {
    /* best-effort: never block navigation on a save failure */
  }
};
